import { render } from "./IconPeople.vue?vue&type=template&id=cdb93a70"
import script from "./IconPeople.vue?vue&type=script&lang=js"
export * from "./IconPeople.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__